// extracted by mini-css-extract-plugin
export const bannerWrapper = "cookie-banner-module--bannerWrapper--1CMDM";
export const banner = "cookie-banner-module--banner--1fww3";
export const inner = "cookie-banner-module--inner--336LI";
export const row = "cookie-banner-module--row--3DPrl";
export const col1 = "cookie-banner-module--col1--3CEPf";
export const col2 = "cookie-banner-module--col2--1R42G";
export const reject = "cookie-banner-module--reject--XpZnm";